// extracted by mini-css-extract-plugin
export default {"empty-content-screen":"Dashboard_empty-content-screen__pzeJk","text":"Dashboard_text__Dbwuj"};